import React from 'react';

const LinkField = (props) => {
    return (
        <React.Fragment>
            {(props.url === "") ? (
                <p>登録されていません。</p>
            ) : (
                <a href={props.url} target= "_blank" rel="noopener noreferrer">{props.url}</a>
            )}
        </React.Fragment>
    );
};

export default LinkField;